/* eslint-disable react/jsx-pascal-case */
import { useEffect, useState, useContext } from 'react'
import * as S from '../styles'
import TextField from '../../TextField'
import Select from '../../Select'
import { useToast } from '../../../hooks/toast'
import clientes from '../../../api/clientes'
import cadastro from '../../../api/cadastro'
import * as val from '../fieldValidator'
import * as mask from '../masks'
import {
  capitalizePhrase,
  noSpecialChars,
  onlyNumber
} from '../../../utils/utils'
import { setUserAddress, setUserInfo } from '../../../store/ducks/user'
import { useDispatch, useSelector } from 'react-redux'
import defaultOptions from '../../../api/defaultoption'
import { getFaturamentoUF } from '../../../pages/MeusEnderecos/validatePJ'
import { validatePJData } from '../../../utils/validateReceitaFederal'
import Loader from '../../Loader'
import { UserContext } from '../../../contexts/UserContext'

const Step2 = ({
  userData,
  cancelar,
  refreshUserData,
  refresh,
  subAtividadeDefault
}) => {
  const { user, setUser, loading, setLoading } = useContext(UserContext)

  const { addToast } = useToast()
  const [localData, setLocalData] = useState({
    idSubAtividade: userData.idSubAtividade
  })
  const [isIsento, setIsIsento] = useState(false)

  const [subAtividade, setSubAtividade] = useState([])
  const [atividades, setAtividades] = useState([])
  const [selectTrigger, setSelectTrigger] = useState(false)
  const [funcionarios, setFuncionarios] = useState([])
  const [cargos, setCargos] = useState([])
  const [departamentos, setDepartamentos] = useState([])
  const [receitaFederalError, setReceitaFederalError] = useState({
    cep: { status: false, message: '' },
    numero: { status: false, message: '' },
    uf: { status: false, message: '' },
    cnpj: { status: false, message: '' },
    inscricaoEstadual: { status: false, message: '' },
    inscricaoMunicipal: { status: false, message: '' },
    nomeFantasia: { status: false, message: '' },
    razaoSocial: { status: false, message: '' }
  })

  const [isInscEstValid, setIsInscEstValid] = useState({
    valid: false,
    message: '',
    showToaster: false
  })

  const store = useSelector((reduxState) => reduxState)
  const dispatch = useDispatch()

  const onChange = (value, field) => {
    setLocalData((prev) => ({
      ...prev,
      [field]: value
    }))

    if (typeof value === 'string') {
      setReceitaFederalError({
        cep: { status: false, message: '' },
        numero: { status: false, message: '' },
        uf: { status: false, message: '' },
        cnpj: { status: false, message: '' },
        inscricaoEstadual: { status: false, message: '' },
        inscricaoMunicipal: { status: false, message: '' },
        nomeFantasia: { status: false, message: '' },
        razaoSocial: { status: false, message: '' }
      })
    }
  }

  const handleReceitaFederalErrorChange = (value, field, message) => {
    setReceitaFederalError((prev) => ({
      ...prev,
      [field]: { status: value, message: message }
    }))
  }

  async function getAddress() {
    // setLoading(true)
    await clientes
      .enderecos(defaultOptions)
      .then((response) => {
        // setLoading(false)
        return response.json()
      })
      .then((obj) => dispatch(setUserAddress(obj)))
      .catch((err) => {
        // if (err) setLoading(false)
      })
  }

  function getEnderecoFaturamento() {
    return store.user.address.filter(
      (address) => address.tipoEndereco === 'C'
    )[0]
  }

  useEffect(() => {
    getAddress()
  }, [])

  const validateInscEstadual = async (inscricaoEstadual, cepUF) => {
    const data = await clientes
      .getInscricaoEstadual(inscricaoEstadual, cepUF)
      .then((res) => res.text())
    if (data.length === 0) {
      setIsInscEstValid({
        valid: true,
        message: '',
        showToaster: true
      })
      return true
    } else {
      // console.log('INVÁLIDO', data)
      setIsInscEstValid({
        valid: false,
        message: data,
        showToaster: true
      })

      return false
    }
  }

  useEffect(() => {
    if (
      localData.inscricaoEstadual !== 'ISENTO' &&
      localData.inscricaoEstadual?.length >= 8
    ) {
      getFaturamentoUF(store.user.address).then((uf) => {
        validateInscEstadual(localData.inscricaoEstadual, uf).then(() => {})
      })
    }
  }, [localData.inscricaoEstadual, store.user.address])

  // useEffect(() => {
  //   console.log(store)
  //   console.log(getFaturamentoUF(store.user.address))
  // }, [store.user.address])

  const apiCall = async () => {
    let cargos = await clientes.cargos()
    let departamentos = await clientes.departamentos()
    let atividades = await clientes.atividades()
    let funcionarios = await clientes.funcionarios()
    cargos = await cargos.json()
    setCargos(cargos)
    atividades = await atividades.json()
    setAtividades(atividades)
    funcionarios = await funcionarios.json()
    setFuncionarios(funcionarios)
    departamentos = await departamentos.json()
    setDepartamentos(departamentos)
  }

  const fetchSubAtividade = async (idAtividade) => {
    if (idAtividade === '') return []
    let req = await clientes.subAtividades(idAtividade)
    req = await req.json()

    // onChange(req, 'idSubAtividade')
    setSubAtividade(req)
    onChange(-1, 'idSubAtividade')
    return req
  }

  async function updateUser(formBody) {
    setLoading(true)
    const resolve = await cadastro.updatePJ(formBody)
    if (resolve.ok) {
      setLoading(false)

      addToast({
        type: 'success',
        title: 'Dados alterados com sucesso'
      })
      refreshUserData(!refresh)
      setUser({ ...user, ...formBody })
      dispatch(setUserInfo(formBody))
      return cancelar()
    } else {
      setLoading(false)

      return addToast({
        type: 'error',
        title: 'Erro ao alterar os dados do usuário'
      })
    }
  }

  useEffect(() => {
    setLocalData(userData)
    apiCall()
    // userData.inscricaoEstadual === 'ISENTO' && onChange('', 'inscricaoEstadual')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!!isIsento) onChange('ISENTO', 'inscricaoEstadual')
  }, [isIsento])

  useEffect(() => {
    if (userData.inscricaoEstadual === 'ISENTO') {
      setIsIsento(true)
    }
  }, [])

  useEffect(() => {
    // if (localData.idAtividade) fetchSubAtividade(localData.idAtividade)
  }, [localData.idAtividade])

  const save = async () => {
    setLoading(true)

    const msg = val.fieldVal(
      [
        localData.contato,
        localData.razaoSocial,

        localData.cnpj,

        localData.telCel,
        localData.telCom
      ],
      [
        val.contatoVal,
        val.razaoVal,

        val.cnpjVal,

        val.cellVal,
        val.comercialPhoneVal
      ]
    )
    if (!!val.selectVal(localData.idSubAtividade)) {
      setSelectTrigger(true)
    } else {
      setSelectTrigger(false)
    }

    if (msg !== '') {
      setLoading(false)

      return addToast({
        type: 'error',
        title: 'Preenchimentos de campo inválidos'
      })
    }

    const formBody = {
      contato: localData.contato,
      // dataAbertura: localData.dataAbertura,
      //idAtividade: +localData.idAtividade,
      //idSubAtividade: +localData.idSubAtividade,
      idCargo: +localData.idCargo,
      idDepartamento: +localData.idDepartamento,
      razaoSocial: localData.razaoSocial,
      //nomeFantasia: localData.nomeFantasia,
      // inscricaoMunicipal: localData.inscricaoMunicipal || null,
      inscricaoEstadual: localData.inscricaoEstadual || 'ISENTO',
      // numeroFuncionariosAdministrativos  localData.numeroFuncionariosAdministrativos,
      // numeroFuncionariosTotal: localData.numeroFuncionariosTotal,
      telefoneCelularDDD: mask.dddString(localData.telCel || userData.telCel),
      telefoneCelularNumero: mask.phoneString(
        localData.telCel || userData.telCel
      ),
      telefoneComercialDDD: mask.dddString(localData.telCom || userData.telCom),
      telefoneComercialNumero: mask.phoneString(
        localData.telCom || userData.telCom
      ),
      telefoneComercialRamal: localData.telefoneComercialRamal
    }

    const enderecoFaturamento = getEnderecoFaturamento()

    const receitaFederalBody = {
      // cnpj: '54651716001150',
      idEtapa: 2,
      cepFaturamento: enderecoFaturamento.cep,
      cnpj: localData.cnpj,
      inscricaoEstadual: localData.inscricaoEstadual,
      numeroEndereco: enderecoFaturamento.numero,
      razaoSocial: localData.razaoSocial,
      uf: enderecoFaturamento.uf
    }

    const mock = {
      idEtapa: 1,
      razaoSocial: 'SUPRICORP SUPRIMENTOS LTDA',
      nomeFantasia: 'GIMBA',
      inscricaoMunicipal: '',
      inscricaoEstadual: '633692849116',
      cepFaturamento: '06422122',
      numeroEndereco: '1160',
      cnpj: '54651716001150',
      uf: 'SP'
    }

    try {
      // console.log('user', userData)
      // console.log(
      //   `Atividade = ${localData.idAtividade} | Sub = ${localData.idSubAtividade}`
      // )
      // console.log('local', localData)

      if (store.user.info.validacaoExternaDadosClientePJ === true) {
        const receitaFederalValidation = await validatePJData(
          receitaFederalBody,
          addToast,
          handleReceitaFederalErrorChange
        )

        if (receitaFederalValidation === 'valid') {
          updateUser(formBody)
        }
      } else {
        updateUser(formBody)
      }

      setLoading(false)
    } catch (e) {
      setLoading(false)

      return addToast({
        type: 'error',
        title: 'Erro ao alterar os dados do usuário'
      })
    }
  }

  return (
    <div>
      {loading && <Loader />}

      <S.WrapperExibition>
        <S.col_group>
          <S.col12>
            <S.form_group>
              <S.label>
                E-mail<S.o>*</S.o>
              </S.label>
              <TextField
                disabled
                name="email"
                placeholder="Email"
                value={localData.email}
                onChange={(e) => onChange(e.target.value, 'email')}
              />
            </S.form_group>
          </S.col12>

          <S.box>
            <S.col4>
              <S.form_group>
                <S.label>
                  Contato<S.o>*</S.o>
                </S.label>
                <TextField
                  maxlength={30}
                  name="contato"
                  placeholder="Contato"
                  value={localData.contato}
                  error={val.contatoVal(localData.contato)}
                  onChange={(e) =>
                    onChange(
                      noSpecialChars(e.target.value.trimStart()),
                      'contato'
                    )
                  }
                  onBlur={(e) => {
                    onChange(
                      e.target.value.trimEnd().replace(/  +/g, ' '),
                      'contato'
                    )
                  }}
                />
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>
                  Departamento<S.o>*</S.o>
                </S.label>

                <Select
                  options={departamentos?.map((item) => {
                    return {
                      value: item.departamentoId,
                      label: item.departamento
                    }
                  })}
                  labelFor="Departamento"
                  value={localData.idDepartamento}
                  onChange={(e) =>
                    onChange(+e.currentTarget.value, 'idDepartamento')
                  }
                />
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>
                  Cargo<S.o>*</S.o>
                </S.label>
                {/*
                {console.log('a', [
                  subAtividade?.filter(
                    (e) => e.subAtividadeId === userData.idSubAtividade
                  )[0]
                ])}

                {console.log(subAtividade)} */}

                <Select
                  options={cargos?.map((item) => {
                    return { value: item.cargoId, label: item.cargo }
                  })}
                  labelFor="Cargo"
                  value={localData.idCargo}
                  onChange={(e) => onChange(e.currentTarget.value, 'idCargo')}
                />
              </S.form_group>
            </S.col4>
          </S.box>

          <S.box>
            <S.col12>
              <S.form_group>
                <S.label>
                  Razão Social<S.o>*</S.o>
                </S.label>
                <TextField
                  maxlength={45}
                  name="razaoSocial"
                  placeholder="Razão Social"
                  value={localData.razaoSocial}
                  error={
                    val.razaoVal(localData.razaoSocial) ||
                    val.validateReceitaError(
                      receitaFederalError.razaoSocial.status,
                      'Razão Social',
                      receitaFederalError.razaoSocial.message
                    )
                  }
                  onChange={(e) =>
                    onChange(
                      noSpecialChars(e.target.value.trimStart()),
                      'razaoSocial'
                    )
                  }
                  onBlur={(e) => {
                    onChange(
                      e.target.value.trimEnd().replace(/  +/g, ' '),
                      'razaoSocial'
                    )
                  }}
                />
              </S.form_group>
            </S.col12>{' '}
            {/*
            <S.col6>
              <S.form_group>
                <S.label>
                  Nome Fantasia<S.o>*</S.o>
                </S.label>
                <TextField
                  maxlength={20}
                  name="nomeFantasia"
                  placeholder="Nome Fantasia"
                  value={localData.nomeFantasia}
                  error={
                    val.contatoVal(localData.nomeFantasia) ||
                    val.validateReceitaError(
                      receitaFederalError.nomeFantasia.status,
                      'Nome Fantasia',
                      receitaFederalError.nomeFantasia.message
                    )
                  }
                  onChange={(e) =>
                    onChange(
                      noSpecialChars(e.target.value.trimStart()),
                      'nomeFantasia'
                    )
                  }
                  onBlur={(e) => {
                    onChange(
                      e.target.value.trimEnd().replace(/  +/g, ' '),
                      'nomeFantasia'
                    )
                  }}
                />
              </S.form_group>
            </S.col6> */}
          </S.box>
          <S.box>
            <S.col6>
              <S.form_group>
                <S.label>
                  CNPJ<S.o>*</S.o>
                </S.label>
                <TextField
                  name="cnpj"
                  placeholder="CNPJ"
                  value={mask.cnpjMask(localData.cnpj)}
                  error={
                    val.cnpjVal(localData.cnpj) ||
                    val.validateReceitaError(
                      receitaFederalError.cnpj.status,
                      'CNPJ',
                      receitaFederalError.cnpj.message
                    )
                  }
                  disabled
                  onChange={(e) =>
                    onChange(mask.cnpjMask(e.target.value), 'cnpj')
                  }
                />
              </S.form_group>
            </S.col6>
            {/*
            <S.col4>
              <S.form_group>
                <S.label>Inscrição Municipal</S.label>
                <TextField
                  name="insMun"
                  placeholder="Inscrição Municipal"
                  value={localData.inscricaoMunicipal}
                  error={val.validateReceitaError(
                    receitaFederalError.inscricaoMunicipal.status,
                    'Inscrição Municipal',
                    receitaFederalError.inscricaoMunicipal.message
                  )}
                  onChange={(e) =>
                    onChange(onlyNumber(e.target.value), 'inscricaoMunicipal')
                  }
                />
              </S.form_group>
            </S.col4>*/}
            <S.col6
              style={{
                marginBottom:
                  receitaFederalError.inscricaoEstadual.status && '25px'
              }}
            >
              <S.form_group>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <S.label>Inscrição Estadual</S.label>
                  <input
                    checked={
                      localData.inscricaoEstadual === 'ISENTO' || !!isIsento
                        ? true
                        : false
                    }
                    type="checkbox"
                    id="isento"
                    onChange={(e) => {
                      onChange(
                        localData.inscricaoEstadual === ('' || 'ISENTO')
                          ? ''
                          : localData.inscricaoEstadual,
                        'inscricaoEstadual'
                      )
                      return onChange(
                        setIsIsento((prev) => !prev),
                        'isento'
                      )
                    }}
                  />
                  <label htmlFor="isento">
                    <p>Isento </p>
                  </label>
                </div>
                <TextField
                  maxlength={14}
                  name="Inscrição Estadual"
                  placeholder="Inscrição Estadual"
                  disabled={localData.inscricaoEstadual === 'ISENTO'}
                  error={
                    (!!localData.inscricaoEstadual?.length &&
                      val.inscEstVal(localData.inscricaoEstadual)) ||
                    val.validateReceitaError(
                      receitaFederalError.inscricaoEstadual.status,
                      'Inscrição Estadual',
                      receitaFederalError.inscricaoEstadual.message
                    )
                  }
                  value={localData.inscricaoEstadual}
                  onChange={(e) =>
                    onChange(onlyNumber(e.target.value), 'inscricaoEstadual')
                  }
                />
              </S.form_group>
            </S.col6>
          </S.box>

          <S.box>
            <S.col4>
              <S.form_group>
                <S.label>
                  Telefone Celular<S.o>*</S.o>
                </S.label>
                <TextField
                  name="telCel"
                  placeholder="Telefone Celular"
                  value={
                    localData.telCel === undefined
                      ? userData.telCel
                      : localData.telCel
                  }
                  error={val.cellVal(localData.telCel)}
                  onChange={(e) =>
                    onChange(mask.cellMask(e.target.value), 'telCel')
                  }
                />
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>
                  Telefone Comercial<S.o>*</S.o>
                </S.label>
                <TextField
                  name="telCom"
                  placeholder="Telefone Comercial"
                  value={
                    localData.telCom === undefined
                      ? userData.telCom
                      : localData.telCom
                  }
                  error={val.comercialPhoneVal(localData.telCom)}
                  onChange={(e) =>
                    onChange(mask.fixPhoneMask(e.target.value), 'telCom')
                  }
                />
              </S.form_group>
            </S.col4>
            <S.col4>
              <S.form_group>
                <S.label>Ramal</S.label>
                <TextField
                  maxlength={10}
                  name="ramal"
                  placeholder="Ramal"
                  value={
                    localData.telefoneComercialRamal === undefined
                      ? userData.telefoneComercialRamal
                      : localData.telefoneComercialRamal
                  }
                  onChange={(e) =>
                    onChange(e.target.value, 'telefoneComercialRamal')
                  }
                />
              </S.form_group>
            </S.col4>
          </S.box>
          <S.perfilBoxFooter>
            <S.AdvanceButton
              onClick={() => {
                // console.log('IE', store.user.info.inscricaoEstadual)
                // console.log(localData.inscricaoEstadual)

                if (localData.inscricaoEstadual === 'ISENTO') {
                  // console.log('validar ISENTO')
                  save()
                } else if (localData.inscricaoEstadual.length < 8) {
                  addToast({
                    type: 'error',
                    title: 'Inscrição Estadual inválida'
                  })
                } else if (
                  !isInscEstValid.valid &&
                  isInscEstValid.showToaster === true
                ) {
                  addToast({
                    type: 'error',
                    title: capitalizePhrase(isInscEstValid.message)
                  })
                } else {
                  // console.log('validar')
                  save()
                }
              }}
            >
              Salvar dados
            </S.AdvanceButton>
            <S.button onClick={() => cancelar()}>Cancelar</S.button>
          </S.perfilBoxFooter>
        </S.col_group>
      </S.WrapperExibition>
    </div>
  )
}

export default Step2
